import React from 'react';
import './Coming-soon.css';

const ComingSoon = () => {
  return (
    <section className="comingsoon-page">
      <div className="comingsoon-overlay" />
      <div className="comingsoon-card">
        <h1 className="comingsoon-title">Coming Soon</h1>
      </div>
    </section>
  );
};

export default ComingSoon;
